



















































































































































































import { Vue, Component,Prop } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import BaseContainer from '@/components/BaseContainer.vue';
// import LocationPanel from '@/components/LocationPanel.vue';
import Trajectory from '@/components/TrajectoryTab.vue';
import CommonPanel from '@/components/CommonPanel.vue';
import { Order, LocationApi ,WayBill} from '@/http';
@Component({
    components: {
        PageDescribe,
        BaseContainer,
        // LocationPanel,
        CommonPanel,
        Trajectory,
    },
})
export default class Location extends Vue {
    public title: string = '在线查看运单信息历史定位信息，用户在线实时定位，支持LBS和北斗的双模定位';
    public $refs: {
        // LocationPanel: HTMLFormElement;
        Trajectory: HTMLFormElement;
    };
    @Prop({default:true})
    showTitle:boolean;
    @Prop()
    public detailData: any;
    public showLocationPanel = false;

    public activities = [];
    public id: any = '';
    public data: any = {};
    public isRegister = false;
    public locationSuc = '';
    public carCode:any = '';
    public deliveryAddress:any = '';
    public arrivalAddress:any = '';
    public driverPhone:any = '';
    public async created() {
        // this.id = this.$route.query.orderId;
        // this.carCode = this.$route.query.carCode;
        // this.deliveryAddress = this.$route.query.deliveryAddress;
        // this.arrivalAddress = this.$route.query.arrivalAddress;
        // this.driverPhone = this.$route.query.driverPhone;
        this.id = this.detailData.id;
        this.driverPhone = this.detailData.driverPhone;
        this.carCode = this.detailData.carCode;
        this.deliveryAddress = this.$route.query.deliveryAddress;
        this.arrivalAddress = this.$route.query.arrivalAddress;
        //console.log('dddddd->',this.detailData);

        this.data = await WayBill.getHistoryLocation({
                     carrierOrderId: this.id,
                     originAddress:this.deliveryAddress,
                     arrivalAddress:this.arrivalAddress,
                     skip:0,
                     count:-1
             });
        let arr = this.data.data.map(v=>{
            return {...v,locationTime:v.locationTime?v.locationTime:''}
        })
        this.$refs.Trajectory.setPoint(arr, this.carCode);
        let res = await WayBill.getLbsStatus({
            phone: this.driverPhone,
        });
        this.isRegister = res.isRegister;
        
        this.activities = [];
        this.data.data.sort(function (a, b) {
            return b.locationTime < a.locationTime ? -1 : 1;
        });
        this.data.data.forEach((item, index) => {
            console.log(index,'44444444444444')
            if (index == 0) {
                this.activities.push({
                    content: item.address,
                    //timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
                    timestamp:item.locationTime,
                    type: '',
                    // color: '#1EAF7D',   
                    icon:'iconfont icon-shou1',               
                });
            }
            // else if(index==1){
            //     this.activities.push({
            //       content:item.address,
            //       timetamp:item.locationTime,
            //       color: '#1EAF7D',
            //       type:''
            //    })
            // }
            else if(index==(this.data.data.length-1)){
               this.activities.push({
                  content:item.address,
                  timestamp:item.locationTime,
                  icon:'iconfont icon-a-jianqudingceng2',
               })
            }
            else {
                this.activities.push({
                    content: item.address,
                    //timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
                    timestamp:item.locationTime,
                    type: '',
                    // color: '#1EAF7D',

                });
            }
        });
    }

    public async init() {
        //this.data = await Order.GetLocationPageResult({ id: this.id });
        this.data = await WayBill.getHistoryLocation({
                     carrierOrderId: this.id,
                     originAddress:this.deliveryAddress,
                     arrivalAddress:this.arrivalAddress,
                     skip:0,
                     count:-1
             });
        let arr = this.data.data.map(v=>{
            return {...v,locationTime:v.locationTime?v.locationTime:''}
        })
        this.$refs.Trajectory.setPoint(arr, this.carCode);
        let res = await WayBill.getLbsStatus({
            phone: this.driverPhone,
        });
        this.isRegister = res.isRegister;
        this.activities = [];
        this.data.data.sort(function (a, b) {
            return b.locationTime < a.locationTime ? -1 : 1;
        });
        this.data.data.forEach((item, index) => {
            // if (index == 0) {
            //     this.activities.push({
            //         content: item.address,
            //         //timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
            //         timestamp:item.locationTime,
            //         type: '',
            //         color: '#0bbd87',
            //     });
            //     // console.log('this.activities1111111111', JSON.stringify(this.activities));
            // } else {
            //     this.activities.push({
            //         content: item.address,
            //         //timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
            //         timestamp:item.locationTime,
            //         type: '',
            //     });
            //     // console.log('this.activities222222222', JSON.stringify(this.activities));
            // }
            if (index == 0) {
                this.activities.push({
                    content: item.address,
                    //timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
                    timestamp:item.locationTime,
                    type: '',
                    // color: '#1EAF7D',
                    icon:'iconfont icon-shou1'
                });
            }
            else if(index==(this.data.data.length-1)){
               this.activities.push({
                  content:item.address,
                  timestamp:item.locationTime,
                  icon:'iconfont icon-a-jianqudingceng2'
               })
            }
            else if(index==1){
                this.activities.push({
                  content:item.address,
                  timestamp:item.locationTime,
                  color: '#1EAF7D',
                  type:''
               })
            }
            else {
                this.activities.push({
                    content: item.address,
                    //timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
                    timestamp:item.locationTime,
                    type: '',
                });
            }
        });
        console.log('activeity-->',this.activities);
    }

    public async DredgeLBS() {
        this.locationSuc = '';
        let res = await WayBill.DredgeLBS({
            phone: this.driverPhone,
        });
        this.$message.success(res.messageInfo);
    }

    public locData: any = {};

    public positionType = 1;
    public llnow = 0

    //GetLocations方法无用 这里先去掉

    public async GetLocation(positionType) {
        //this.showLocationPanel = true;
        this.locationSuc = '';
        this.positionType = positionType;
        // let res = await LocationApi.GetLocation({
        //     positionType: positionType,
        //     phone: this.data.driverPhone,
        //     carCode: this.data.carCode,
        //     carrierOrderId: this.data.carrierOrderId,
        // });
        let res = await WayBill.getzndw({
            positionType: positionType,
            carrierOrderId: this.id,
        });
        console.log('jfoiewf',res);
        if (positionType == 1) {
            if (res) {
                //console.log('lbs-->',res);
                this.locData = res;
                this.init();
                this.llnow = 1
                this.locationSuc = '定位成功';
            } else {
                this.$message.warning('定位失败');
                this.locationSuc = '定位失败';
            }
        } else {
            if (res) {
                console.log('北斗',res);
                this.locData = res;
                this.init();
                this.llnow = 2
                this.locationSuc = '定位成功';
            } else {
                this.$message.warning('定位失败');
                this.locationSuc = '定位失败';
            }
        }

    }

    public mounPageDescribeted() {}

    public searchLoctaion() {
        // let locData = await LocationApi.GetLocation(this.searchValue);
        // this.$refs.LocationPanel.setPoint(locData.longitude, locData.latitude, locData.area, locData.creationTime);
        // let locList = await LocationApi.GetLocationList({ ...this.searchValue, serviceType: 2 });
        // console.log('locList' + JSON.stringify(locList));
        // this.activities = [];
        // locList.data.forEach((item, index) => {
        //     if (index == 0) {
        //         this.activities.push({
        //             content: item.area,
        //             timestamp: item.creationTime,
        //             type: 'danger',
        //             serviceTypeStr: item.serviceTypeStr,
        //         });
        //     } else {
        //         this.activities.push({
        //             content: item.area,
        //             timestamp: item.creationTime,
        //             serviceTypeStr: item.serviceTypeStr,
        //             type: '',
        //         });
        //     }
        // });
    }

    back() {
        this.$router.push('./WayBillManage');
    }
}
